// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class HighlightSliderModule extends ModuleBase {
  public activeSlide: number = 1;
  public highlights: object = {};
  public highlightsMobile: Array<any> = [];
  public popupOpen: boolean = false;
  public popup: object = {
    image: "",
    headline: "",
    text: "",
  };

  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  public async created() {
    this.prepareHighlights();
  }

  public mounted() {}

  public destroyed() {}

  public handleTransition(activeSlide) {
    //-1 to match the array
    this.activeSlide = activeSlide - 1;
  }

  public prepareHighlights() {
    for (let i = 0; i < this.instance["section_images"].length; i++) {
      if (this.instance["section_images"][i].highlights.length) {
        this.highlights[i] = this.instance["section_images"][i].highlights;

        //check if one of the highlights should be shown on mobile
        this.instance["section_images"][i].highlights.forEach((highlight) => {
          if (highlight.mobile) this.highlightsMobile.push(highlight);
        });
      }
    }
  }

  public openPopup(spin, index) {
    this.popup["headline"] = this.highlights[spin][index]["headline"];
    this.popup["image"] = this.highlights[spin][index]["image"];
    this.popup["text"] = <HTMLElement>this.highlights[spin][index]["text"];

    this.popupOpen = true;
  }

  public closePopup() {
    this.popupOpen = false;
  }

  get getColorClass() {
    let color = this.instance["section_text"]["color"];
    return color == "white" ? "white" : "black";
  }
}
